module.exports = __webpack_public_path__ + "static/media/chill-spins-300x100-transparent.e493544c.png";